import React, { SFC } from 'react'

import { SpinnerLoader } from '../../../shared'

import { TableColumn } from './table-column.component'
import { TableRow } from './table-row.component'

export const TableRowLoader: SFC = () => {
  return (
    <TableRow>
      <TableColumn colSpan={20}>
        <SpinnerLoader />
      </TableColumn>
    </TableRow>
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-row-loader.tsx